Handlebars.registerPartial('partials/common/change_history/change-history-row', Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <tr>\n    <td>\n      "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"localDate") : depth0), depth0))
    + "\n    </td>\n    <td>\n      "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"sub_entity_type") : depth0), depth0))
    + "\n    </td>\n    <td>\n      "
    + alias2((lookupProperty(helpers,"i18nMsg")||(depth0 && lookupProperty(depth0,"i18nMsg"))||container.hooks.helperMissing).call(alias3,(depth0 != null ? lookupProperty(depth0,"sub_entity_operation_type") : depth0),{"name":"i18nMsg","hash":{},"data":data,"loc":{"start":{"line":10,"column":6},"end":{"line":10,"column":48}}}))
    + "\n    </td>\n    <td class=\"nameEmail\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"actor_details") : depth0)) != null ? lookupProperty(stack1,"email") : stack1), depth0))
    + "\">\n      <div class=\"truncate\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"actor_details") : depth0)) != null ? lookupProperty(stack1,"first_name") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"actor_details") : depth0)) != null ? lookupProperty(stack1,"last_name") : stack1), depth0))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,((stack1 = (depth0 != null ? lookupProperty(depth0,"actor_details") : depth0)) != null ? lookupProperty(stack1,"email") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":16,"column":13}}})) != null ? stack1 : "")
    + "    </td>\n  </tr>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"truncate\">("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"actor_details") : depth0)) != null ? lookupProperty(stack1,"email") : stack1), depth0))
    + ")</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"history") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":19,"column":9}}})) != null ? stack1 : "");
},"useData":true}));